import { ResourceCategory } from './resources';

export interface Configuration {
  basePath: string;
  accessToken: string;
}

export class ResourcesService {
  private config: Configuration;

  constructor(configuration: Configuration) {
    this.config = configuration;
  }

  async fetchResources(path: string): Promise<Response> {
    const headers = this.getHeaders();
    return fetch(`${this.config.basePath}/${path}`, {
      headers,
    });
  }

  getHeaders(): Headers {
    const headers = new Headers();
    if (this.config.accessToken) {
      headers.set('Authorization', `Bearer ${this.config.accessToken}`);
    }

    return headers;
  }

  async getCategories(): Promise<ResourceCategory[]> {
    return this.fetchResources('categories').then((resp) => {
      return resp.json();
    });
  }

  async getMessages(): Promise<ResourceCategory[]> {
    return this.fetchResources(`messages`).then((resp) => {
      return resp.json();
    });
  }
}
export const getConfiguration = (accessToken: string): Configuration => {
  const resourcesURL = '/api/resource';
  const configuration: Configuration = { basePath: resourcesURL, accessToken };

  return configuration;
};

export const getAuthLink = (
  event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  link: string,
  accessToken: string,
) => {
  // Prevents '#' from href from being added to url
  event.preventDefault();

  fetch('/api/resource' + link, {
    method: 'GET',
    headers: new Headers({
      Authorization: 'Bearer ' + accessToken,
    }),
  })
    .then((response) => response.blob())
    .then((blob) => {
      if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
        (window.navigator as any).msSaveOrOpenBlob(blob);
      } else {
        var url = window.URL.createObjectURL(blob);
        var element = document.createElement('a');
        element.href = url;
        element.target = '_blank';
        element.rel = 'noopener noreferrer';
        element.click();
        element.remove();
      }
    })
    .catch((error) => error);
};

export default ResourcesService;
